import Image, { StaticImageData } from 'next/image'

type TestimonialProps = {
  review: string
  name: string
  role: string
  image: StaticImageData
}

function TestimonialCard({ testimonial }: { testimonial: TestimonialProps }) {
  return (
    <div className="shadow-card flex !w-full flex-col gap-6 rounded-3xl border border-[#1C1D2A] bg-[#0D0E18] px-6 py-4 md:max-w-[397.33px] lg:px-8 lg:py-6">
      <p className="leading-[150%] tracking-[-0.16px] text-white/80">
        {testimonial.review}
      </p>

      <div className="flex items-center gap-4">
        <Image
          src={testimonial.image}
          alt="Chevron down"
          className="w-[56px] rounded-full object-cover"
        />

        <div className="flex flex-col gap-[2px]">
          <h4 className="text-[15px] font-semibold leading-[150%] tracking-[-0.15px]">
            {testimonial.name}
          </h4>
          <h5 className="text-[13px] leading-[150%] tracking-[-0.13px] text-white/80">
            {testimonial.role}
          </h5>
        </div>
      </div>
    </div>
  )
}

export default TestimonialCard
